import { BaseIP } from "../CommonAPI/CommonApi";

export const Demo=BaseIP+""  // Demo API

//=======================================================DIspatch =============================
export const GenerateDispatchNo =BaseIP+ "dispatch/generateDispatch"
export const SaveDispatchDetails = BaseIP +"dispatch/saveDispatch"
export const UpdateDispatchDetails = BaseIP + "dispatch/updateDispatch"
export const GetDispatchDetails = BaseIP +"dispatch/getDispatchList"
export const GetDispatchDetailsById = BaseIP +"dispatch/getDispatch"
export const DeleteDispatchDetais = BaseIP + "dispatch/deleteDispatch"
export const GetDispatchPackingDetails = BaseIP + "dispatch/getPackingInfo"
export const GetDispatchDataByMonth = BaseIP + "dispatch/getDispatchesByMonth"
export const ChangeStatusOfDispatch = BaseIP + "dispatch/changeDispatchStatus"
export const DeletePackingDispatchData = BaseIP + "dispatch/deleteDispatch"
export const ReportDispatch = BaseIP + "reports/dispatchReport/generateDispatchReport"
//=======================Job Work ===============================================================
export const SaveJobWork = BaseIP +"jobWork/saveJobWork"
export const GetJobWorkDetails = BaseIP +"jobWork/viewJobWork"
export const GenerateJobWorkNo = BaseIP +"jobWork/generateJobWork"
export const GetJobWorkPackingDetails = BaseIP +"jobWork/getPackingInfo"
export const DeletePackingJobWorkData = BaseIP+ "jobWork/deleteJobWork"
export const ChangeStatusOfJobWork = BaseIP + "jobWork/changeJobStatus"
export const SelectedJobWorkDetails = BaseIP + "jobWork/view"
//=================== Job Work Dispatch =====================================================
export const GetJobWorkDetailsDispatch = BaseIP +"jobWorkDispatch/getJobWorkDispatchDetails"
export const SaveJObWorkDispatch = BaseIP +"jobWorkDispatch/saveJobWorkDispatch"
export const GetAllJobWorkDispatch =BaseIP + "jobWorkDispatch/getAlljobWorkDispatch"
export const GetJobWorkDropdown = BaseIP +"jobWorkDispatch/findByJobWorkerId"
//================= Dispatch delivery Summary ===================================================
export const DispatchDeliverySummarySave = BaseIP +"dispatchDelivery/saveDispatchDelivery"
export const DispatchNumberByCustomerId = BaseIP + "dispatchDelivery/dispatchnumbers"
export const GetDetailsByDispatchNUmberId = BaseIP +"dispatchDelivery/getOrderNumber"
export const GetOrderDetailsDispatchDeliveryByOrderNumber = BaseIP +"dispatchDelivery/getOrderNumberDetails"
export const GetDispatchDeliverySummaryDetails = BaseIP + "dispatchDelivery/getDispatchDeliveryList"
//============ Common Dispatch and JObwork  delivery Summary =========================================
export const GetConsigneeForCustomer = BaseIP + "jobWorkDelivery/getConsignee"

//============= JobWork delivery Summary =========================================================
export const JobWorkNumberByCUstomerId = BaseIP + "jobWorkDelivery/jobworknumbers"
export const GetOrderDetailsJobWorkDeliveryByOrderNumber = BaseIP +"jobWorkDelivery/getOrderNumberDetails"
export const JobWorkDeliverySummarySave = BaseIP +"jobWorkDelivery/saveJobWorkDelivery"
export const GetJobWorkDeliverySummaryDetails = BaseIP + "jobWorkDelivery/getJobWorkDeliveryList"
export const GetDetailsByJobWorkNUmberId = BaseIP +"jobWorkDelivery/getOrderNumber"